import { render, staticRenderFns } from "./MessageResultBody.vue?vue&type=template&id=aba2ec8c"
import script from "./MessageResultBody.vue?vue&type=script&lang=js"
export * from "./MessageResultBody.vue?vue&type=script&lang=js"
import style0 from "./MessageResultBody.vue?vue&type=style&index=0&id=aba2ec8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports